import React, { useState } from 'react';
import { Grid } from '@mui/material';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import { downloadFile } from '../../utils/downloadFile';
import { Alert, type AlertDetails, type FileData } from '..';
import { useAuth } from '../../contexts';

type DisplayFileDataProps = {
  fileData: FileData[];
};

export const DisplayFileData: React.FunctionComponent<DisplayFileDataProps> = (
  props: DisplayFileDataProps,
) => {
  const { fileData } = props;
  const { handleLoading } = useAuth();
  const [openAlert, setOpenAlert] = useState(false);
  const [alertDetails, setAlertDetails] = useState<AlertDetails>({
    alertContent: '',
    alertType: 'error',
  });

  const handleDownLoadFile = async (
    fileId: string,
    fileName: string,
  ): Promise<void> => {
    await handleLoading(async () => {
      try {
        await downloadFile(fileId, 'pdf', fileName);
      } catch (error) {
        setOpenAlert(true);
        setAlertDetails({
          alertType: 'error',
          alertContent: 'Error Occurs.' + (error as Error)?.message,
        });
      }
    });
  };

  return (
    <>
      <Alert
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertDetails={alertDetails}
      />
      {(fileData ?? [])?.length === 0 ? (
        <Grid size={5}>
          <div className="flex items-start mb-4">
            <FileOpenIcon className="text-[#951d1d]" />
            <i className="ml-2">{'N/A'}</i>
          </div>
        </Grid>
      ) : (
        <Grid className="!text-sm" size={5}>
          {(fileData ?? []).map((doc, index) => {
            const { id, name } = doc ?? {};
            return (
              <div key={index}>
                <div
                  className="flex items-start cursor-pointer"
                  onClick={async () => {
                    await handleDownLoadFile(id, name);
                  }}
                >
                  <FileOpenIcon className="text-[#951d1d]" />
                  {name ? (
                    <a className="underline italic">&nbsp;{name}</a>
                  ) : (
                    <i className="ml-2">{'N/A'}</i>
                  )}
                </div>
              </div>
            );
          })}
        </Grid>
      )}
    </>
  );
};
